<template>
  <div v-if="mode=='info'" v-html="model[prop]"></div>
  <div v-else-if="mode=='form'">
    <quill-editor v-model="model[prop]" :config="quillConfig" @ready="onEditorReady($event)"
      @focus="onEditorFocus($event)" ref="htmlEditor"></quill-editor>
    <!-- Dropping Links Area -->
    <div v-if="selectedInfobitIdKnown" class="drop-link-area" v-dragula="[]" bag="infobits"
      v-html="(!textSelection)
      ? 'Drop an infobit to create a link' : 'Drop an infobit to create a link labelled &ldquo;' + textSelection + '&rdquo;'">
    </div>
  </div>
</template>

<script>

import PasteAction from '../../paste-action.js'
import Quill from 'quill'
let Inline = Quill.import('blots/inline')

class InfobitLink extends Inline {
  static create (value) {
    let node = super.create()
    node.setAttribute('class', 'clickable')
    node.setAttribute('data-infobit-id', value.id)
    node.setAttribute('data-link-id', value.linkId)
    node.setAttribute('title', value.htmlTitle)
    return node
  }

  static formats (node) {
    return {
      id: Number(node.getAttribute('data-infobit-id')),
      linkId: Number(node.getAttribute('data-link-id')),
      htmlTitle: node.getAttribute('title')
    }
  }
}
// ### Fixme: Move InfobitLink format impl into its own class/file
InfobitLink.blotName = 'infobitLink'
InfobitLink.tagName = 'infobit-link'

export default {
  props: ['mode', 'model', 'prop'],
  data () {
    return {
      quillConfig: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'code'],
            ['blockquote', 'code-block'],
            [{'list': 'ordered'}, {'list': 'bullet'}],
            [{'header': [1, 2, 3, false]}],
            ['link', 'infobit-link', 'infobit-clipboard', 'image', 'video']
          ]
        },
        placeholder: undefined
      }
    }
  },

  computed: {
    editor () {
      if (this.mode === 'form') {
        this.$store.state.detailPanel.quillEditor = this.$refs.htmlEditor.quillEditor
        return this.$refs.htmlEditor.quillEditor
      } else {
        this.$store.state.detailPanel.quillEditor = undefined
      }
    },
    clipboardContent () {
      return this.$store.state.clipboard.content
    },
    textSelection () {
      return this.$store.state.detailPanel.selectedText
    },
    selectedInfobitIdKnown () {
      return (this.$store.state.infobitId)
    }
  },

  watch: {
    clipboardContent: function (newContent) {
      if (this.mode === 'form') {
        if (newContent && this.selectedInfobitIdKnown) {
          // content in clipboard and infobit id is known, activate buttons
          renderPasteLinkButton(true, this)
        } else if (!this.selectedInfobitIdKnown) { // no content in clipboard and no id known, deactivate buttons
          renderPasteLinkButton(false, this)
          renderLinkByIdButton(false, this)
        }
      }
    }
  },

  updated () {
    // attach infobit-link handler here, no eed for 400ms timeout in detail-panel
    if (this.mode === 'info') {
      attachInfobitLinkHandler(this.$store.dispatch)
    } else if (this.selectedInfobitIdKnown && this.mode === 'form') {
      renderLinkByIdButton(true, this)
    } else if (!this.selectedInfobitIdKnown && this.mode === 'form') {
      renderLinkByIdButton(false, this)
    }
  },

  created () {
    if (this.mode === 'info') {
      attachInfobitLinkHandler(this.$store.dispatch)
    }
    registerInfobitLinkFormat()
  },

  methods: {
    onEditorFocus ($event) {
      var range = this.editor.getSelection()
      this.setTextCursorRange(range)
    },
    onEditorReady ($event) {
      // Initialize custom buttons for the Quill toolbar (see toolbar config)
      // 1) Link Infobit Button
      var linkButton = document.querySelector('.ql-infobit-link')
      linkButton.addEventListener('click', this.infobitLinkButton)
      linkButton.innerHTML = '<span class="fa fa-fw fa-info-circle" title="Link Infobit by ID"></span>'
      // 2) Paste Infobit Button
      var clipboardButton = document.querySelector('.ql-infobit-clipboard')
      clipboardButton.setAttribute('disabled', true)
      clipboardButton.innerHTML = '<span class="fa fa-fw fa-paste" title="Paste link to Infobit"></span>'
      // 3.1) Listen on text editor cursor position changes
      var htmlField = this
      this.editor.on('text-change', function (delta, oldContents, source) {
        updateTextSelectionRange(htmlField)
      })
      this.editor.on('selection-change', function (range, oldRange, source) {
        updateTextSelectionRange(htmlField)
      })
      updateTextSelectionRange(htmlField)
    },
    getInvolvedInfobitLinks (delta) {
      var links = []
      for (var dx in delta.ops) {
        if (delta.ops[dx].hasOwnProperty('attributes')) {
          if (delta.ops[dx].attributes.hasOwnProperty('infobitLink')) {
            links.push(delta.ops[dx])
          }
        }
      }
      return links
    },
    infobitLinkButton (event) {
      var selectedRange = this.$store.state.detailPanel.textCursorRange
      var formattingState = this.editor.getFormat(selectedRange)
      if (this.hasInfobitLinkAttribute(formattingState)) { // allow for selected removal of formatting
        this.editor.formatText(selectedRange.index, selectedRange.length, 'infobitLink', false)
        var assocId = formattingState.infobitLink.linkId
        var linkContinues = this.hasNeighbouringInfobitLink(selectedRange)
        if (!linkContinues) {
          this.$store.dispatch('deleteInfobitLinkAssoc', {assocId})
        } else {
          console.log('infobitLinkButton continues left|right of current cursor, no deletion of infobitLink')
        }
      } else {
        var promptInput = window.prompt('Bitte eine Infobit ID eingeben')
        var infobitIdInput = parseInt(promptInput)
        var sourceInfobitId = this.$store.state.infobitId
        this.$store.dispatch('fetchInfobit', {infobitId: infobitIdInput}).then(infobit => {
          if (infobit) {
            this.insertInfobitLinkFormat(infobit)
          } else {
            console.error('Could not load infobit to link it with source', sourceInfobitId)
          }
        })
      }
    },
    infobitClipboardButton (event) {
      var clipboardAction = this.$store.state.clipboard.action
      var targetInfobit = this.$store.state.clipboard.content
      if (clipboardAction === PasteAction.INSERT) {       // inserting infobit
        this.insertInfobitLinkFormat(targetInfobit)
        this.$store.state.clipboard.content = undefined
        this.$store.state.clipboard.action = undefined
      } else if (clipboardAction === PasteAction.MOVE || clipboardAction === PasteAction.COPY ||
          clipboardAction === PasteAction.TRANSCLUDE) {   // inserting tree node
        this.insertInfobitLinkFormat(targetInfobit.infobit)
        this.$store.state.clipboard.content = undefined
        this.$store.state.clipboard.action = undefined
      } else {
        console.error('Unknown clipboardAction', clipboardAction, 'content', targetInfobit)
      }
    },
    insertInfobitLinkFormat (targetInfobit) {
      var sourceInfobit = this.$store.state.detailPanel.infobit
      if (targetInfobit && sourceInfobit) {
        console.log('insertInfobitLink from source', sourceInfobit.id, 'to target', targetInfobit.id)
        this.$store.dispatch('createInfobitLink', {sourceInfobit, targetInfobit})
      } else {
        console.error('Could not format infobitLink as target', targetInfobit, 'sourceInfobit', sourceInfobit)
      }
    },
    hasInfobitLinkRight (range) {
      var right = range.index + range.length
      var rightContent = this.editor.getFormat(right, 1)
      return this.hasInfobitLinkAttribute(rightContent)
    },
    hasInfobitLinkLeft (range) {
      var left = range.index - 1
      var leftContent = this.editor.getFormat(left, 1)
      return this.hasInfobitLinkAttribute(leftContent)
    },
    hasNeighbouringInfobitLink () {
      var range = this.$store.state.detailPanel.textCursorRange
      return (this.hasInfobitLinkLeft(range) || this.hasInfobitLinkRight(range))
    },
    hasInfobitLinkAttribute (format) {
      return format.hasOwnProperty('infobitLink')
    },
    setTextCursorRange (range, oldRange) {
      if (range) {
        this.$store.state.detailPanel.textCursorRange = range
      } else if (oldRange) {
        this.$store.state.detailPanel.textCursorRange = oldRange
      } else if (!range && !oldRange) { // HTML Input Field not :focussed, initializing textCursorRange (0, 0)
        this.$store.state.detailPanel.textCursorRange = { index: 0, length: 0 }
      }
    },
    getSelectedText () {
      if (this.editor) {
        var range = this.$store.state.detailPanel.textCursorRange
        return this.editor.getText(range.index, range.length)
      }
    },
    getInfobitLinkElements () {
      var links = document.getElementsByTagName('infobit-link')
      var elements = []
      for (var l in links) {
        if (typeof links[l] === 'object') {
          elements.push(links[l])
        }
      }
      return elements
    }
  },

  components: {
    'quill-editor': require('vue-quill-editor/editor.vue')
  }

}

function registerInfobitLinkFormat () {
  // ### TODO: check if format is already registered to avoid multiple registration (which seem unproblematic)
  Quill.register('formats/infobitLink', InfobitLink) // Note: vue-quill-editor _requires_ 1st param
}

function attachInfobitLinkHandler (dispatch) {
  var elements = getInfobitLinkElements()
  if (elements.length > 0) {
    for (var l in elements) {
      elements[l].addEventListener('click', function (event) {
        var infobitId = Number(event.target.getAttribute('data-infobit-id'))
        dispatch('toggleLinkTreeSelector', { id: infobitId, mouseEvent: event })
      })
    }
  }
}

function getInfobitLinkElements () {
  var links = document.getElementsByTagName('infobit-link')
  var elements = []
  for (var l in links) {
    if (typeof links[l] === 'object') {
      elements.push(links[l])
    }
  }
  return elements
}

function renderPasteLinkButton (isActive, component) {
  var clipboardButton = document.querySelector('.ql-infobit-clipboard')
  var clipboardLabel = document.querySelector('.ql-infobit-clipboard span')
  if (isActive && clipboardButton) {
    clipboardButton.removeAttribute('disabled')
    clipboardButton.addEventListener('click', component.infobitClipboardButton)
    clipboardLabel.setAttribute('title', 'Paste link to Infobit')
  } else if (clipboardButton) {
    clipboardButton.removeEventListener('click', component.infobitClipboardButton)
    clipboardButton.setAttribute('disabled', true)
    clipboardLabel.setAttribute('title', 'Deactivated: You must save your infobit first ' +
      'to link to others from it.')
  }
}

function renderLinkByIdButton (isActive, component) {
  var infobitLinkButton = document.querySelector('.ql-infobit-link')
  var infobitLinkLabel = document.querySelector('.ql-infobit-link span')
  if (!isActive && infobitLinkButton) {
    infobitLinkButton.removeEventListener('click', component.infobitClipboardButton)
    infobitLinkButton.setAttribute('disabled', true)
    infobitLinkLabel.setAttribute('title', 'Deactivated: You must save your infobit first ' +
      'to link to others from it.')
  }
}

function updateTextSelectionRange (htmlField) {
  var range = htmlField.editor.getSelection()
  htmlField.setTextCursorRange(range)
  if (range && range.length > 0) {
    htmlField.$store.state.detailPanel.selectedText = htmlField.getSelectedText()
  } else {
    htmlField.$store.state.detailPanel.selectedText = undefined
  }
}
</script>

<style>
.html-field infobit-link {
  text-decoration: underline;
}

.drop-link-area {
  border: 1px dotted #c7c7c7;
  border-top: 0px solid transparent;
  font-size: var(--small-font-size);
  color: gray;
  width: 75%;
  height: 4em;
  padding: .5em;
}

.ql-editor {
  padding-left: 8px !important;
  padding-right: 8px !important;
  font-size: var(--main-font-size);
}

.ql-editor p + p {
  margin-top: 1em;
}

button.ql-infobit-simple-link .fa:hover,
button.ql-infobit-link .fa:hover,
button.ql-infobit-clipboard .fa:hover,
.ql-snow.ql-toolbar button:hover,
.ql-snow.ql-toolbar button.ql-active,
.ql-snow.ql-toolbar .ql-picker-label:hover,
.ql-snow.ql-toolbar .ql-picker-label.ql-active,
.ql-snow.ql-toolbar .ql-picker-item:hover,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected {
  color: var(--hotspot-hover-color) !important;
}

.ql-snow.ql-toolbar button:hover .ql-fill,
.ql-snow.ql-toolbar button.ql-active .ql-fill,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-fill,
.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill,
.ql-snow.ql-toolbar .ql-picker-item:hover .ql-fill,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill,
.ql-snow.ql-toolbar button:hover .ql-stroke.ql-fill,
.ql-snow.ql-toolbar button.ql-active .ql-stroke.ql-fill,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,
.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,
.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill {
  fill: var(--hotspot-hover-color) !important;
}

.ql-snow.ql-toolbar button:hover .ql-stroke,
.ql-snow.ql-toolbar button.ql-active .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
.ql-snow.ql-toolbar button:hover .ql-stroke-miter,
.ql-snow.ql-toolbar button.ql-active .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter {
  stroke: var(--hotspot-hover-color) !important;
}
</style>



// WEBPACK FOOTER //
// html-field.vue?2f42ae02